module.exports = __webpack_public_path__ + "static/parade-2020-house57-f48185a755a8b2ef154c2eeba57f374e.jpg";